const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID;
const PRO_LABEL = process.env.REACT_APP_GOOGLE_ADS_PRO_LABEL;

const fired = new Set();

// Fires the Google Ads purchase conversion once per checkout session (Google also dedupes on transaction_id).
export function trackProConversion(sessionId, value = 8.99) {
  if (!ADS_ID || typeof window.gtag !== "function") return;
  if (fired.has(sessionId)) return;
  fired.add(sessionId);
  window.gtag("event", "conversion", {
    send_to: PRO_LABEL ? `${ADS_ID}/${PRO_LABEL}` : ADS_ID,
    value,
    currency: "USD",
    transaction_id: sessionId,
  });
}

// Fires the Google Ads sign-up conversion (generic event on the base tag).
export function trackSignupConversion(userId) {
  if (!ADS_ID || typeof window.gtag !== "function") return;
  window.gtag("event", "conversion", { send_to: ADS_ID, event_category: "sign_up", transaction_id: `signup_${userId}` });
  window.gtag("event", "sign_up", { method: "email" });
}
